/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatfocusplaceholder2Inputs */

const en_formatfocusplaceholder2 = /** @type {(inputs: Formatfocusplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. the singer's face, closer up`)
};

const de_formatfocusplaceholder2 = /** @type {(inputs: Formatfocusplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. das Gesicht der Sängerin, näher heran`)
};

/**
* | output |
* | --- |
* | "e.g. the singer's face, closer up" |
*
* @param {Formatfocusplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const formatfocusplaceholder2 = /** @type {((inputs?: Formatfocusplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatfocusplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatfocusplaceholder2(inputs)
	return de_formatfocusplaceholder2(inputs)
});
export { formatfocusplaceholder2 as "formatFocusPlaceholder" }